import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'brfood';

  ngAfterViewInit() {
    const observer = new MutationObserver(() => {
      const pane = document.querySelector(
        '.cdk-overlay-pane:has(.mat-mdc-snack-bar-container)'
      ) as HTMLElement;

      if (pane) {
        pane.style.position = 'fixed';
        pane.style.bottom = '0';
        pane.style.left = '50%';
        pane.style.transform = 'translateX(-50%)';
        pane.style.zIndex = '2147483647';
        pane.style.backgroundColor = '#ffffff';
        pane.style.margin = '0px';
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


}
